import React from "react";

function ErrorMessage({ error, visible, style }) {
  if (!error || !visible) return null;
  return <span style={{ color: "red" }}>{error}</span>;
}

export default ErrorMessage;
